//
import { queryList } from '../api';
const ssoLoading = {
  namespaced: true,
  state: {
    resp: {},
    total: null,
    addLog: null
  },
  mutations: {
    QUERY_LIST(state, resp) {
      state.resp = resp.obj || {};
    }
  },
  actions: {
    async queryListInfo({ commit }, obj) {
      let resp = await queryList(obj);
      commit('QUERY_LIST', resp);
    }
  }
}

export default ssoLoading



// WEBPACK FOOTER //
// ./src/page/sso/ssoLoading/store/ssoLoading.store.js